import { createFileRoute } from '@tanstack/react-router';

import ComingSoonCover from '@/components/ComingSoonCover';

export const Route = createFileRoute(
  '/_staff/starlinks/_layout/_placeholders/billing-and-cost',
)({
  component: () => <ComingSoonCover />,
});
